export { default as favicon } from './favicon_de.png';
export { default as icon } from './logo_icon.png';
export { default as login } from './logo_large.png';
